__turbopack_context__.v({
  "container": "Scrollable-module-scss-module__mObj7a__container",
  "list": "Scrollable-module-scss-module__mObj7a__list",
});
